import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';
import $ from 'jquery';
import {copyRight} from '../../../utils/Variables';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Nav,Navbar,NavDropdown,Row,Col,Table,Modal} from 'react-bootstrap';
import NOIMAGE from '../../../assets/img/noimage.jpg';
import ARROW_TOP_RIGHT from '../../../assets/img/arrow-top-right.png';
import FullPageLoader from '../../../containers/FullPageLoader';
import ReactFileReader from 'react-file-reader';

const styles = {
	patientImg: {
		width: '169px',
		cursor: 'pointer',
		border: '1px solid #dcdcdc',
	}
}

class Add extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('loginUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'SAVE PROFILE',
			isRedirect: false,
			showLoader: false,
			showFullLoader: false,
			showAddModal: false,
			groupData: [],
			patientId: '',
			patientCode: '',
			selectedFile: '',
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleFiles = this.handleFiles.bind(this);
	}
	
	componentDidMount(){
		
		this.loadPatientId();
	}
	
	loadPatientId(){
		this.setState({showFullLoader:true});
		var token = Reqst.TimeStamp();
		Reqst.axGet('patientmaster/getpatientid/'+this.state.masterId+'/'+this.state.companyId+'/'+token).then(res=>{
			if(res['data'].status=='1')
			{
				this.setState({patientId: res['data'].pid, patientCode: res['data'].pcode, showFullLoader:false});	
			}
			else
			{
				this.setState({showFullLoader:false});	
			}
		});
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		this.setState({showLoader:true,saveText:'Saving..'});
		//var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('patientmaster/saveprofile',$("#frmAdd").serialize()).then(res=>{
			if(res['data'].status=='1')
			{
				document.getElementById("frmAdd").reset();
				notify.show(res['data'].msg,'success');
				this.setState({showLoader:false,saveText:'SAVE PROFILE', patientId: res['data'].pid, patientCode: res['data'].pcode, selectedFile: ''});
				if(this.props.afterFinish) this.props.afterFinish();
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false,saveText:'SAVE PROFILE'});
			}
		});
	}
	
	handleFiles(files){
		try{
			
			this.setState({selectedFile: files.base64});
		}
		catch(error){ }
	}

	render(){
		
		const IMG = this.state.selectedFile.length>5 ? this.state.selectedFile : NOIMAGE;
		
		return(
			<div>			
				<FullPageLoader loading={this.state.showFullLoader} />
				
				<form  action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<input type="hidden" name="i__picture" value={this.state.selectedFile} />
					
					<Row>
						<Col md={9} >
							<Row>
								<Col md={6} >
									<label >Patient Id <span className="text-danger">*</span></label>
									<input type="text" name="i__code" id="i__code" className="form-control input-sm" value={this.state.patientCode} readOnly />
								</Col>
								<Col md={6} >
									<label >Patient Type <span className="text-danger">*</span></label>
									<select name="i__type" id="i__type" className="form-control input-sm" required >
										<option value="NORMAL" > NORMAL </option>
										<option value="VIP" > VIP </option>
										<option value="VVIP" > VVIP </option>
									</select>
								</Col>
							</Row>
							<Row>
								<Col md={6} >
									<label >Patient Name <span className="text-danger">*</span></label>
									<input type="text" name="i__name" id="i__name" className="form-control input-sm" required  />
								</Col>
								<Col md={6} >
									<label >Patient Mobile <span className="text-danger">*</span></label>
									<input type="number" name="i__mobile" id="i__mobile" className="form-control input-sm" required  />
								</Col>
							</Row>
							<Row>
								<Col md={4} >
									<label >Date of Birth <span className="text-danger"></span></label>
									<input type="date" name="i__dob" id="i__dob" className="form-control input-sm"  />
								</Col>
								<Col md={2} >
									<label >Age <span className="text-danger"></span></label>
									<input type="number" name="i__age" id="i__age" className="form-control input-sm"  />
								</Col>
								<Col md={6} >
									<label >Gender <span className="text-danger">*</span></label>
									<select name="i__gender" id="i__gender" className="form-control input-sm" required >
										<option value="Male"> Male </option>
										<option value="Female"> Female </option>
										<option value="TG"> TG </option>
									</select>
								</Col>
							</Row>
							<Row>
								<Col md={6} >
									<label >Place <span className="text-danger"></span></label>
									<input type="text" name="i__place" id="i__place" className="form-control input-sm"   />
										<label >Email Id <span className="text-danger"></span></label>
									<input type="email" name="i__email" id="i__email" className="form-control input-sm"   />
								</Col>
								<Col md={6} >
									<label >Address <span className="text-danger"></span></label>
									<textarea type="text" name="i__address" id="i__address" className="form-control input-sm"  rows="5" ></textarea>
								</Col>
							</Row>
							<Row>
								<Col md={6} >
									<label >Whatsapp <span className="text-danger"></span></label>
									<input type="number" name="i__whatsapp" id="i__whatsapp" className="form-control input-sm"   />
								</Col>
								<Col md={6} >
									<label>Active Status <span className="text-danger">*</span></label>
									<select name="i__status" id="i__status" className="form-control input-sm" required >
										<option value="1"> Active </option>
										<option value="0"> In Active </option>
									</select>
								</Col>
								<Col md={12} >
									<label>Notes <span className="text-danger"></span></label>
									<textarea className="form-control input-sm" rows="3" name="i__remarks" id="i__remarks" ></textarea>
								</Col>
							</Row>
							
						</Col>
						<Col md={3} >
							<ReactFileReader handleFiles={this.handleFiles} base64={true} >
								<img src={IMG} style={styles.patientImg} />
							</ReactFileReader>
							{this.state.selectedFile.length>5 ?
							<button type="button" className="btn btn-warning btn-block btn-sm" onClick={()=>{this.setState({selectedFile:''})}} >
								Remove Image
							</button> : null}
							
							<div className="text-center" >
								<img src={ARROW_TOP_RIGHT} />
								<br />
								Click over the image to upload new one.!
							</div>
							
						</Col>
					</Row>
					
					
					
				
					<Row>
						<Col md={12} >
							<div className="text-right" style={{ marginTop: 25 }} >
								<button type="reset" className="btn btn-danger btn-sm btn-danger" disabled={this.state.saveText!='SAVE PROFILE'} >
									<i className="fa fa-remove"></i> CLEAR
								</button>
							&nbsp;
								<button type="submit" className="btn btn-primary btn-sm btn-success_2" disabled={this.state.saveText!='SAVE PROFILE'} >
									<i className="fa fa-check"></i> {this.state.saveText} 
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}
	
}
export default Add;